<!-- Overlay -->
@if (shopCartService.isOpen$ | async) {
  <div
    class="fixed inset-0  bg-gray-950/50 z-50 transition-opacity"
    (click)="closeCart()"
  ></div>
}

<!-- Loader Component -->
<app-loader-subito></app-loader-subito>

<!-- Modal de direcciones vacías -->
<app-modal-empty-addresses-user></app-modal-empty-addresses-user>

<!-- Sidebar -->
<div
  class="fixed right-0 top-0 h-full w-full xs:w-[85%] sm:w-[75%] md:w-96 bg-white z-50 transform transition-transform duration-300 ease-in-out shadow-xl overflow-hidden"
  [ngClass]="
    (shopCartService.isOpen$ | async) ? 'translate-x-0' : 'translate-x-full'
  "
  >
  <!-- Header -->
  <div
    class="flex items-center justify-between p-3 sm:p-4 sticky top-0 bg-white z-10 ios-status-bar-padding"
    >
    <h2 class="text-lg sm:text-xl font-bold">Tu pedido</h2>
    <button (click)="closeCart()" class="p-2 hover:bg-gray-100 rounded-full">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-5 w-5 sm:h-6 sm:w-6"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M6 18L18 6M6 6l12 12"
          />
      </svg>
    </button>
  </div>

  <!-- Cart Items -->
  <div class="flex-1 overflow-y-auto h-[calc(100vh-180px)] p-3 sm:p-4">
    <!-- Empty State -->
    @if (cartProducts().length === 0) {
      <div
        class="flex flex-col items-center justify-center h-full text-gray-500"
        >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-16 w-16 sm:h-24 sm:w-24 mb-3 sm:mb-4"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"
            />
        </svg>
        <p class="text-base sm:text-lg font-medium">Tu carrito está vacío</p>
        <p class="text-xs sm:text-sm">¡Agrega productos para comenzar!</p>
      </div>
    }
    <!-- Productos deshabilitados -->
    @if (hasDisabledProducts()) {
      <div class="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg">
        <div class="flex items-center justify-between mb-2">
          <h3 class="text-sm font-medium text-red-800">Productos no disponibles</h3>
          <button
            (click)="clearCart()"
            [disabled]="isClearing()"
            class="text-xs text-red-600 hover:text-red-800 underline"
            >
            Eliminar todos
          </button>
        </div>
        <p class="text-xs text-red-600 mb-3">Los siguientes productos ya no están disponibles y deben ser eliminados antes de proceder al pago:</p>

        @for(product of cartProductsDisabled(); track product.product_id) {
          <div class="flex items-center gap-2 p-2 bg-red-100 rounded-md mb-2 opacity-60">
            <img
              [src]="product.image"
              [alt]="product.name"
              class="w-12 h-12 object-cover rounded-md grayscale"
              (error)="onImageError($event)"
              />
            <div class="flex-1 min-w-0">
              <h4 class="text-sm font-medium text-red-800 truncate">{{ product.name }}</h4>
              <p class="text-xs text-red-600">Cantidad: {{ product.quantity }}</p>
            </div>
            <button
              (click)="removeProduct(product.shoppingCartDetails_id!)"
              [disabled]="isProductRemoving(product.shoppingCartDetails_id!)"
              class="px-2 py-1 text-xs bg-red-500 text-white rounded hover:bg-red-600 transition-colors relative"
              >
              <span [class.invisible]="isProductRemoving(product.shoppingCartDetails_id!)">Eliminar</span>
              @if (isProductRemoving(product.shoppingCartDetails_id!)) {
                <div
                  class="absolute inset-0 flex items-center justify-center"
                  >
                  <svg
                    class="animate-spin h-3 w-3 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    >
                    <circle
                      class="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      stroke-width="4"
                    ></circle>
                    <path
                      class="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 714 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                </div>
              }
            </button>
          </div>
        }
      </div>
    }

    <!-- Cart Items -->
    @for(product of cartProducts(); track product.product_id + (product.variations && product.variations.length > 0 ? product.variations[0].name : '')) {
      <div
        class="flex items-center gap-2 sm:gap-4 p-3 sm:p-4 bg-white rounded-lg shadow-sm mb-3 flex-wrap sm:flex-nowrap"
        [class.opacity-50]="isProductDisabled(product.product_id)"
        [class.pointer-events-none]="isProductDisabled(product.product_id)"
        >
        <img
          [src]="product.image"
          [alt]="product.name"
          class="w-16 h-16 sm:w-20 sm:h-20 object-cover rounded-lg"
          (error)="onImageError($event)"
          />
        <div class="flex-1 min-w-0">
          <!-- Added min-w-0 to prevent text overflow -->
          <h3 class="font-medium text-sm sm:text-base truncate">
            {{ product.name }}
          </h3>
          <p class="text-xs sm:text-sm text-gray-500 truncate">
            {{ nameEstablishment()}}
          </p>
          <p class="text-xs sm:text-sm text-gray-500 truncate">
            Cantidad {{ product.quantity }}
          </p>

          <!-- Botón para expandir/colapsar variaciones y complementos -->
          @if (hasVariationsOrComplements(product)) {
            <button
              (click)="toggleProductExpanded(product.product_id)"
              class="flex items-center gap-1 text-xs text-blue-600 hover:text-blue-800 mt-1 transition-colors"
              >
              <svg
                class="w-3 h-3 transition-transform duration-200"
                [class.rotate-90]="getProductExpanded(product.product_id)()"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                >
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
              </svg>
              <span>{{ getProductExpanded(product.product_id)() ? 'Ocultar' : 'Ver' }} detalles</span>
            </button>

            <!-- Contenido expandible -->
            @if (getProductExpanded(product.product_id)()) {
              <div class="mt-2 p-2 bg-gray-50 rounded-md text-xs space-y-1">
                <!-- Variaciones -->
                @if (product.variations && product.variations.length > 0) {
                  <div class="border-b border-gray-200 pb-1 mb-1">
                    <p class="font-medium text-gray-700 mb-1">Variaciones:</p>
                    @for (variation of product.variations; track variation.name) {
                      <div class="flex justify-between items-center">
                        <span class="text-gray-600">• {{ variation.name }}</span>
                        @if (variation.priceAdjustment && variation.priceAdjustment !== '.00' && variation.priceAdjustment !== '0.00') {
                          <span class="text-green-600 font-medium">+{{ variation.priceAdjustment | currency }}</span>
                        }
                      </div>
                    }
                  </div>
                }

                <!-- Complementos -->
                @if (product.complements && product.complements.length > 0) {
                  <div>
                    <p class="font-medium text-gray-700 mb-1">Complementos:</p>
                    @for (complement of product.complements; track complement.name) {
                      <div class="flex justify-between items-center">
                        <span class="text-gray-600">• {{ complement.name }}</span>
                        @if (complement.priceComplement && complement.priceComplement !== '.00' && complement.priceComplement !== '0.00') {
                          <span class="text-green-600 font-medium">+{{ complement.priceComplement | currency }}</span>
                        }
                      </div>
                    }
                  </div>
                }
              </div>
            }
          }
          <div class="flex items-center gap-1 sm:gap-2 mt-1 sm:mt-2">
            <button
              (click)="decrementQuantity(product.shoppingCartDetails_id!)"
              [disabled]="isProductUpdating(product.shoppingCartDetails_id!)"
              class="w-6 h-6 sm:w-8 sm:h-8 flex items-center justify-center bg-gray-100 rounded-full text-sm sm:text-base touch-manipulation relative transition-all duration-200"
              [class.opacity-50]="isProductUpdating(product.shoppingCartDetails_id!)"
              >
              <span [class.invisible]="isProductUpdating(product.shoppingCartDetails_id!)">-</span>
              @if (isProductUpdating(product.shoppingCartDetails_id!)) {
                <div
                  class="absolute inset-0 flex items-center justify-center"
                  >
                  <svg
                    class="animate-spin h-3 w-3 text-gray-500"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    >
                    <circle
                      class="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      stroke-width="4"
                    ></circle>
                    <path
                      class="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                </div>
              }
            </button>
            <span class="text-base sm:text-lg font-medium px-1 sm:px-2">
              {{ getProductQuantity(product.product_id, product.quantity)() }}
            </span>
            <button
              (click)="updateQuantity(product.shoppingCartDetails_id!)"
              [disabled]="isProductUpdating(product.shoppingCartDetails_id!)"
              class="w-6 h-6 sm:w-8 sm:h-8 flex items-center justify-center bg-gray-100 rounded-full text-sm sm:text-base touch-manipulation relative transition-all duration-200"
              [class.opacity-50]="isProductUpdating(product.shoppingCartDetails_id!)"
              >
              <span [class.invisible]="isProductUpdating(product.shoppingCartDetails_id!)">+</span>
              @if (isProductUpdating(product.shoppingCartDetails_id!)) {
                <div
                  class="absolute inset-0 flex items-center justify-center"
                  >
                  <svg
                    class="animate-spin h-3 w-3 text-gray-500"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    >
                    <circle
                      class="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      stroke-width="4"
                    ></circle>
                    <path
                      class="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                </div>
              }
            </button>
          </div>
        </div>
        <div class="text-right">
          <p class="font-medium text-sm sm:text-base">
            ${{ product.subtotal }}
          </p>
          <button
            (click)="removeProduct(product.shoppingCartDetails_id!)"
            [disabled]="isProductRemoving(product.shoppingCartDetails_id!)"
            class="text-red-500 text-xs sm:text-sm mt-1 px-2 py-1 hover:bg-red-50 rounded relative transition-all duration-200"
            [class.opacity-50]="isProductRemoving(product.shoppingCartDetails_id!)"
            >
            <span [class.invisible]="isProductRemoving(product.shoppingCartDetails_id!)"
              >Eliminar</span
              >
              @if (isProductRemoving(product.shoppingCartDetails_id!)) {
                <div
                  class="absolute inset-0 flex items-center justify-center"
                  >
                  <svg
                    class="animate-spin h-4 w-4 text-red-500"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    >
                    <circle
                      class="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      stroke-width="4"
                    ></circle>
                    <path
                      class="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                </div>
              }
            </button>
          </div>
        </div>
      }
    </div>

    <!-- Footer -->
    <div class="p-3 sm:p-4 bg-white sticky bottom-0 z-10">
      <div class="flex justify-between mb-3 sm:mb-4">
        <span class="text-gray-600 text-sm sm:text-base">Subtotal</span>
        <div class="relative">
          <span [class.invisible]="isUpdatingSubtotal()" class="font-medium text-sm sm:text-base">${{ cartTotal() }}</span>
          @if (isUpdatingSubtotal()) {
            <div class="absolute inset-0 flex items-center justify-center">
              <svg class="animate-spin h-4 w-4 text-gray-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
            </div>
          }
        </div>
      </div>

      <button
        [disabled]="cartProducts().length === 0 || isAnyOperationInProgress() || hasDisabledProducts()"
      [ngClass]="
        cartProducts().length === 0 || isAnyOperationInProgress() || hasDisabledProducts()
          ? 'bg-gray-400 cursor-not-allowed'
          : 'bg-green-400 hover:bg-green-500 active:bg-green-600 transition-colors'
      "
        class="w-full py-2 sm:py-3 text-white rounded-full font-medium text-sm sm:text-base touch-manipulation relative"
        (click)="proceedToPayment()"
        >
        <span [class.invisible]="isAnyOperationInProgress()">
          {{ hasDisabledProducts() ? 'Elimina productos no disponibles' : 'Ir a pagar ($' + cartTotal() + ')' }}
        </span>
        @if (isAnyOperationInProgress()) {
          <div
            class="absolute inset-0 flex items-center justify-center"
            >
            <svg
              class="animate-spin h-5 w-5 text-white mr-2"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              >
              <circle
                class="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                stroke-width="4"
              ></circle>
              <path
                class="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              ></path>
            </svg>
            <span class="text-sm">Procesando...</span>
          </div>
        }
      </button>
      <button
        [disabled]="cartProducts().length === 0 || isClearing()"
        (click)="clearCart()"
      [ngClass]="
        cartProducts().length === 0 || isClearing()
          ? 'bg-gray-400 cursor-not-allowed'
          : 'bg-red-400 hover:bg-red-500 active:bg-red-600 transition-colors'
      "
        class="w-full py-2 mt-2 text-white rounded-full font-medium text-xs sm:text-sm touch-manipulation relative"
        >
        <span [class.invisible]="isClearing()">Vaciar carrito</span>
        @if (isClearing()) {
          <div
            class="absolute inset-0 flex items-center justify-center"
            >
            <svg
              class="animate-spin h-5 w-5 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              >
              <circle
                class="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                stroke-width="4"
              ></circle>
              <path
                class="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              ></path>
            </svg>
          </div>
        }
      </button>
    </div>
  </div>
